import { useStore } from 'vuex';
import GroupPost from '../GroupPost/GroupPost.vue';
import { computed, onMounted } from 'vue';
import getLabelFromStore from '../../foundation/js/getLabel'

export default {
    name: "UserPostsList",
    components: {
        GroupPost
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        groupId: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            default: 0
        },
        take: {
            type: Number,
            default: 10
        },
        userData: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const store = useStore()
        const isLoggedIn = computed(() => store.state.main.user.user_authorized ?? false)
        const posts = computed(() => store.state.search.results[props.guid] ?? [])
        const totalNumberOfPosts = computed(() => store.state.search.scoped_total[props.guid] ?? 0)
        const showSpinner = computed(() => store.state.search.search_inprogress[props.guid])
        
        const getLabel = (key, strings) => {
            let label = getLabelFromStore({
                labelKey: key,
                labelCollection: 'UserPostsList'
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        const getApiPath = () => {
            switch (props.type) {
                case 'saved': 
                    return process.env.GET_SAVED_POSTS_LIST
                default:
                    return process.env.GET_USER_POSTS_LIST
            }
        }

        onMounted(() => {
            const api = getApiPath()

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: api
            })         

            store.dispatch('search/performSearch', {
                guid: props.guid,
                guery: '',
                skip: props.skip,
                take: props.take
            })
        })

        const handlePostClick = (e, post) => {
            window.location.href = post.url
        }

        const getMorePosts = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        return {
            isLoggedIn,
            posts,
            totalNumberOfPosts,
            showSpinner,
            getLabel,
            handlePostClick,
            getMorePosts
        }
    }
}